<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
    <van-divider>我加入的俱乐部</van-divider>
    <van-cell-group v-if="row.club.id">
      <van-cell :title="row.club.danwei"  @click="goClub"
                value="审核成功" is-link v-if="row.club.registstatus==2">
       <template #label> 
         <div class="tiny-btn-0" style="display: block;float:left;margin-right:10px" @click.stop="unbindClub()">解除绑定</div>
         <div v-show="row.club_list.length>1" class="tiny-btn-0" style="display: block;float:left" @click.stop="sheetActiveShow=true">切换俱乐部</div>
       </template>
      </van-cell>
      <van-cell :title="row.club.danwei" :value="row.club.registstatus==1 ? '等待审核' : ''" v-else @click="toClubNext(row.club.id)">
        <template #right-icon>
          <div class="tiny-btn-1">查看详情</div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group v-else>
      <van-cell title="新增俱乐部" @click="toClub">
        <template #right-icon>
          <div class="tiny-btn-1">点击创建</div>
        </template>
      </van-cell>
    </van-cell-group>

    <van-divider>我的考级中心（点）</van-divider>
    <van-cell-group v-if="row.center.id">
      <van-cell :title="row.center.danwei" @click="goCenter" 
                value="审核成功" is-link v-if="row.center.kaojiregist_status==2">

       <template #label> 
         <div class="tiny-btn-0" style="display: block;float:left;margin-right:10px" @click.stop="unbindCenter()">解除绑定</div>
         <div v-show="row.center_list.length>1"  class="tiny-btn-0" style="display: block;float:left" @click.stop="centerActiveShow=true">切换考级中心/点</div>
       </template>

      </van-cell>
      <van-cell :title="row.center.danwei" :value="row.center.kaojiregist_status==1 ? '等待审核' : ''" v-else @click="toKaojiNext(row.center.id)">
        <template #right-icon>
          <div class="tiny-btn-1">查看详情</div>
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group v-else>
      <van-cell title="考级中心/考级点" @click="toKaoji">
        <template #right-icon>
          <div class="tiny-btn-1">点击创建</div>
        </template>
      </van-cell>
    </van-cell-group>

<!--    <van-divider>已有俱乐部/考级中心/考级点</van-divider>-->
<!--    <van-cell-group>-->
<!--      <van-cell title="已有俱乐部/考级中心/考级点" @click="toAuth">-->
<!--        <template #right-icon>-->
<!--          <div class="tiny-btn-1">点击认证</div>-->
<!--        </template>-->
<!--      </van-cell>-->
<!--    </van-cell-group>-->

    <div class="savebtn" v-if="loading">
      <!-- <van-button 
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round
          @click="toClub">创建俱乐部
      </van-button> -->

      <van-button 
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal" round @click="toKaoji">创建考级中心（点）
      </van-button>
    </div>

    <van-dialog v-model="clubShow" title="" class="dialog-box" :showConfirmButton="false">
      <div class="dialog-head">创建须知</div>
      <div class="dialog-content">
        <!-- <div class="dialog-step-li">1.首次申请，默认成为一星俱乐部，如需升级星级详见俱乐部申报流程；</div>

        <div class="dialog-step-li">2.俱乐部升级类别</div>
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）二星俱乐部</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）三星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（3）四星俱乐部</div>
          </li>
          <li class="dialog-li">
            <div class="li-left">（4）五星俱乐部</div>
          </li>
        </ul> -->


<!--        <div class="dialog-step-li">3.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/</div>-->
        <div class="dialog-step-li">附件下载
<!--          <div class="dialog-step-li-text"-->
<!--               @click="download('啦啦操星级俱乐部管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf')">-->
<!--            啦啦操星级俱乐部管理办法-->
<!--          </div>-->
          <div>
          <van-button
              type="primary"
               @click="download('啦啦操星级俱乐部管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf')">
            啦啦操星级俱乐部管理办法
          </van-button>
          </div>
        </div>

        <van-button type="primary" size="large" @click="toClubNext(0)">
          <div>我已阅读并同意遵守本须知声明的所有条款</div>
          <div>点击进行创建</div>
        </van-button>
        <van-button type="default" size="large" @click="clubShow = false">我再想想</van-button>
      </div>
    </van-dialog>
    <van-dialog v-model="kaojiShow" title="" class="dialog-box" :showConfirmButton="false">
      <div class="dialog-head">创建须知</div>
      <div class="dialog-content">
        <div class="dialog-step-li">1.可创建类型为：</div>
 
        <ul>
          <li class="dialog-li">
            <div class="li-left">（1）七彩星级考级点（预备）0元</div>
            <div class="li-right">0元</div>
          </li>

          <li class="dialog-li">
            <div class="li-left">（2）七彩星级指定样板考级点</div>
            <div class="li-right">9800元</div>
          </li> 
          <li class="dialog-li">
            <div class="li-left">（3）七彩星级指定样板考级中心</div>
            <div class="li-right">135000元</div>
          </li>
        </ul>

        <div class="dialog-step-li">2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/</div>

        <div class="dialog-step-li">3.附件下载
          <div class="dialog-step-li-text"
               @click="download('啦啦操七彩星级管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf')">
            啦啦操七彩星级管理办法
          </div>
          <div class="dialog-step-li-text"
               @click="download('七彩星级考级中心（点）加盟方案', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf')">
            七彩星级考级中心（点）加盟方案
          </div>
<!--          <div class="dialog-step-li-text"-->
<!--               @click="download('考级点文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-10.zip')">-->
<!--            考级点文化包（兼容版）请下载制作-->
<!--          </div>-->
<!--          <div class="dialog-step-li-text"-->
<!--               @click="download('考级中心文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-12.zip')">-->
<!--            考级中心文化包（兼容版）请下载制作-->
<!--          </div>-->
        </div>

        <van-button type="primary" size="large" @click="toKaojiNext(0)">
          <div>我已阅读并同意遵守本须知声明的所有条款</div>
          <div>点击进行创建</div>
        </van-button>
        <van-button type="default" size="large" @click="kaojiShow = false">我再想想</van-button>
      </div>
    </van-dialog>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>


    <van-action-sheet
      v-model="sheetActiveShow"
      description="将以新的俱乐部主体参赛报名"
      :actions="row.club_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelect"
    />



    <van-action-sheet
      v-model="centerActiveShow"
      description="将以考级中心/点申报考级"
      :actions="row.center_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelectCenter"
    />


  </div>
</template>
<style scoped>
.gray-back>>>.van-cell__label{
  width: 300px !important;
}
.dialog-head {
  font-size: .5rem;
  font-weight: 700;
  text-align: center;
  padding: .4rem 0 .3rem;
}

.dialog-content {
  padding: 0 .3rem;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: .2rem 0 .3rem;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from '@/components/LoginDialog.vue';

import {
  Cell,
  Field,
  Dialog,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Dialog).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubIndex',
  components: {
    PicUploader,
    LoginDialog
  },
  data: function () {
    return {
      validator,
      loading: false,
      clubShow: false,
      kaojiShow: false,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      row: {
        danwei: {},
        center: {},
        club: {},
        center_list: [],
        club_list: []
      },
      formData: {},
      sheetActiveShow:false, 
      centerActiveShow:false, 
    }
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "我的俱乐部"
    this.fetch();
  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/user/certindexOwn', {}, (res) => {
        that.row = res.data;
        that.loading = true
      }, (res) => {

        that.loading = true
        console.log('errrrrr')
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink({
              name: 'login', 'query': {}
            }, 'replace');
            return false;
          }
          that.loginShow = true
        } else {
          Toast(res.msg)
        }
      })
    },
    toClub() {
      this.clubShow = true
    },

    toKaoji() {
      this.kaojiShow = true
    },

    // 官网已有考级中心认证
    toAuth() {
      rbLink({
        name: 'QcxjStationBind',
      });
    },

    // 创建俱乐部
    toClubNext(id) {
      // rbLink({
      //   name: 'ClubApplyMine',
      //   query: {
      //     id: id
      //   }
      // });
    },

    // 创建考级中心/点
    toKaojiNext(id) {
      rbLink({
        name: 'QcxjStationApplyMine',
        query: {
          id: id
        }
      });
    },

    // 下载附件
    download(name, url) {
      appEvent({
        name: 'downloadFile',
        query: {
          name: name,
          url: url
        }
      });
    },
    loginSuccess(res) {
      console.log('-------登录成功--------', res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log('-------取消登录--------');
      // this.loginShow = false;
    },

    onSheetCancel() {
      // Toast('取消');
    },

    onSelect(action,index){
      console.log(action,index)   
      let that = this;
      that.$api.post('/api/club/clubChange', {
        club_id  : action.id
      }, (res) => { 
          Toast('您的俱乐部已切换成【'+ action.name+'】');
          that.fetch();
      }, (res) => { 
      })
    },

    onSelectCenter(action,index){
      console.log(action,index)   
      let that = this;
      that.$api.post('/api/examecenter/centerChange', {
        center_id  : action.id
      }, (res) => { 
          Toast('您的考级中心/点已切换成【'+ action.name+'】');
          that.fetch();
      }, (res) => { 
      })
    },


    unbindClub() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除绑定该俱乐部吗?'
      }).then(() => {

        that.$api.post('/api/club/clubUserUnBind', {
          club_id:that.row.club.id
        }, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },



    unbindCenter() {
      let that = this;
      Dialog.confirm({
        title: '确认',
        message: '确认要解除绑定该考级中心/点吗?'
      }).then(() => {

        that.$api.post('/api/examecenter/centerUserUnBind', {
          center_id:that.row.center.id
        }, (res) => {
          that.fetch();
        }, (res) => {

        })

//                    that.onPaySuccess();
      }).catch(() => {
//                    that.onPayError();
      });
    },

    goClub(){
      rbLink({name:'ClubDetail', query: {id: this.row.club.id}});
    },
    goCenter(){
      rbLink({name:'QcxjDetail', query: {id: this.row.center.id}});
    }


  }
}
</script>



// WEBPACK FOOTER //
// ClubIndex.vue?4c31c7dc